// Theme configuration for the application
const theme = {
  colors: {
    primary: '#E94057',
    primaryLight: '#F06478',
    primaryDark: '#D13046',
    secondary: '#7ECBB9',
    secondaryLight: '#9FDECF',
    secondaryDark: '#65A395',
    purple: '#8B6EB4',
    purpleLight: '#A48CC8',
    purpleDark: '#735A95',
    accent: '#FFAA8A',
    dark: '#2D3142',
    light: '#F8F9FA',
    white: '#FFFFFF',
    gray: '#6C757D'
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    largeDesktop: '1200px'
  },
  borderRadius: '16px',
  boxShadow: '0 8px 20px rgba(233, 64, 87, 0.1)',
  transition: 'all 0.3s ease'
};

export default theme;
